import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Delete, AddCircleOutline } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import Notify from "../../../../Notify";
import { getData } from "../../../../../services/library";
import { UrlApi } from "../../../../../services/apirest";

let contadorLineasNuevas = 0;
const generarKey = () => `nueva-${Date.now()}-${contadorLineasNuevas++}`;

function EdicionEntregaRemito(props) {
  const [disBtn, setDisBtn] = useState(false);
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const [renglones, setRenglones] = useState(null);
  const [datosRenglon, setDatosRenglon] = useState([]);
  const [productos, setProductos] = useState([]);

  const handleClose = () => {
    props.onClose(false);
  };

  const obtenerRenglones = () => {
    getData(
      "/envasado_pedidos_renglon/renglones/" + props.factura.uuid_pedido,
      setRenglones
    );
  };

  useEffect(() => {
    obtenerRenglones();
    getData("/productos/envasados", setProductos);
  }, []);

  useEffect(() => {
    setDatosRenglon(
      (renglones || []).map((renglon) => ({ ...renglon, _key: renglon.id }))
    );
  }, [renglones]);

  const cargando = renglones === null;
  const lineasActivas = datosRenglon.filter((renglon) => !renglon.eliminado);

  const getProductoById = (id) =>
    productos ? productos.find((producto) => producto.idproducto === id) : null;

  const handleCantidadChange = (key, value) => {
    setDatosRenglon((prev) =>
      prev.map((renglon) =>
        renglon._key === key ? { ...renglon, cantidad: value } : renglon
      )
    );
  };

  const handleProductoChange = (key, value) => {
    setDatosRenglon((prev) =>
      prev.map((renglon) =>
        renglon._key === key
          ? { ...renglon, producto: value ? value.idproducto : null }
          : renglon
      )
    );
  };

  const agregarLinea = () => {
    setDatosRenglon((prev) => [
      ...prev,
      {
        _key: generarKey(),
        uuid_pedido: props.factura.uuid_pedido,
        producto: null,
        cantidad: 1,
        especificaciones: "",
      },
    ]);
  };

  const eliminarLinea = (key) => {
    setDatosRenglon((prev) => {
      const renglon = prev.find((r) => r._key === key);
      if (renglon && renglon.id) {
        return prev.map((r) =>
          r._key === key ? { ...r, eliminado: true } : r
        );
      }
      return prev.filter((r) => r._key !== key);
    });
  };

  const datosValidos = () =>
    lineasActivas.length > 0 &&
    lineasActivas.every(
      (renglon) =>
        renglon.producto &&
        Number.isInteger(Number(renglon.cantidad)) &&
        Number(renglon.cantidad) > 0
    );

  const guardar = async (e) => {
    e.preventDefault();

    if (!datosValidos()) {
      setNotificacion({
        open: true,
        mensaje:
          "Todos los renglones deben tener producto y una cantidad entera mayor a 0.",
        severity: "warning",
        color: "#F6DDCC",
      });
      return;
    }

    setDisBtn(true);
    try {
      for (const renglon of datosRenglon) {
        if (renglon.eliminado) {
          if (renglon.id) {
            await fetch(`${UrlApi}/envasado_pedidos_renglon/${renglon.id}`, {
              method: "PUT",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                activo: 0,
                usuario_edicion_remito: localStorage.getItem("user"),
              }),
            });
          }
        } else if (renglon.id) {
          await fetch(`${UrlApi}/envasado_pedidos_renglon/${renglon.id}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              producto: renglon.producto,
              cantidad: Number(renglon.cantidad),
              usuario_edicion_remito: localStorage.getItem("user"),
            }),
          });
        } else {
          await fetch(`${UrlApi}/envasado_pedidos_renglon`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              uuid_pedido: props.factura.uuid_pedido,
              producto: renglon.producto,
              cantidad: Number(renglon.cantidad),
              especificaciones: renglon.especificaciones || "",
              usuario_edicion_remito: localStorage.getItem("user"),
            }),
          });
        }
      }
      handleClose();
    } catch (error) {
      console.error("Error al actualizar renglones:", error.message);
      setNotificacion({
        open: true,
        mensaje: "Error al guardar los renglones: " + error.message,
        severity: "error",
        color: "#F1948A",
      });
      setDisBtn(false);
    }
  };

  return (
    <div>
      <Dialog open={props.open} onClose={handleClose} fullWidth maxWidth="sm">
        {notificacion && notificacion.open ? (
          <Notify
            mensaje={notificacion.mensaje}
            open={notificacion.open}
            color={notificacion.color}
            handleClose={() => {
              setNotificacion({ open: false });
            }}
            severity={notificacion.severity}
          />
        ) : null}
        <form onSubmit={guardar}>
          <Box backgroundColor={"#1F618D"}>
            <DialogTitle>
              <Typography color="#ffffff" fontSize={20}>
                Editar Cantidades de Entrega con Remito{" "}
                {props.factura.remito_entrega}
              </Typography>
            </DialogTitle>
          </Box>
          <DialogContent>
            {cargando ? (
              <DialogContentText textAlign={"center"}>
                Cargando renglones...
              </DialogContentText>
            ) : (
              <Stack spacing={1.5} mt={1}>
                {lineasActivas.length === 0 ? (
                  <DialogContentText textAlign={"center"}>
                    No hay renglones cargados.
                  </DialogContentText>
                ) : (
                  lineasActivas.map((renglon) => (
                    <Box
                      key={renglon._key}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        p: 1.5,
                        borderRadius: "8px",
                        backgroundColor: "#f8f9fa",
                        border: "1px solid #e0e0e0",
                      }}
                    >
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        {renglon.id ? (
                          <>
                            <Typography fontWeight={600} fontSize={"0.9rem"}>
                              {renglon.nombre}
                            </Typography>
                            {renglon.especificaciones ? (
                              <Typography
                                fontSize={"0.78rem"}
                                color="text.secondary"
                              >
                                {renglon.especificaciones}
                              </Typography>
                            ) : null}
                          </>
                        ) : (
                          <Autocomplete
                            disabled={!productos}
                            disableClearable
                            size="small"
                            noOptionsText="Producto no encontrado"
                            options={productos || []}
                            autoHighlight
                            getOptionLabel={(producto) =>
                              `${producto.codigoproducto} - ${producto.nombre}`
                            }
                            value={getProductoById(renglon.producto)}
                            onChange={(event, value) =>
                              handleProductoChange(renglon._key, value)
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                size="small"
                                placeholder="Buscar producto..."
                                variant="outlined"
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    backgroundColor: "white",
                                    borderRadius: "6px",
                                  },
                                }}
                              />
                            )}
                          />
                        )}
                      </Box>
                      <Box sx={{ width: "110px" }}>
                        <TextField
                          label="Cantidad"
                          size="small"
                          type="number"
                          required
                          inputProps={{
                            min: 1,
                            style: { textAlign: "center" },
                          }}
                          value={renglon.cantidad ?? ""}
                          onChange={(e) =>
                            handleCantidadChange(renglon._key, e.target.value)
                          }
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: "white",
                              borderRadius: "6px",
                            },
                          }}
                        />
                      </Box>
                      <Tooltip title="Eliminar renglón" arrow>
                        <IconButton
                          size="small"
                          onClick={() => eliminarLinea(renglon._key)}
                        >
                          <Delete fontSize="small" color="error" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  ))
                )}
                <Button
                  startIcon={<AddCircleOutline />}
                  onClick={agregarLinea}
                  sx={{ alignSelf: "flex-start" }}
                >
                  Agregar renglón
                </Button>
              </Stack>
            )}
          </DialogContent>
          <DialogActions>
            <Stack spacing={45} direction="row">
              <Button
                color="error"
                disabled={disBtn}
                variant="contained"
                onClick={handleClose}
              >
                Cancelar
              </Button>
              <Button
                color="success"
                type="submit"
                variant="contained"
                disabled={disBtn || cargando}
              >
                Confirmar
              </Button>
            </Stack>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}

export default EdicionEntregaRemito;
